import {fork} from 'redux-saga/effects';
import * as Watcher from './watcher';

export default function* rootSaga(): Generator {
    yield fork(Watcher.GetEvent);
    yield fork(Watcher.GetEvents);
}
